import { z } from "zod";
import { BladeCommonSchema } from "../common";
import { AsyncConfigSchema } from "../../fragments/AsyncConfig";
import { BackdropSchema } from "../../fragments/Backdrop";
import { BladeHeaderSchema } from "../../fragments/BladeHeader";
export const GameCardFlagSchema = z.object({
    id: z.string(),
    label: z.string(),
    color: z.string().optional(),
});
export const GameCardItemSchema = z.object({
    number: z.number(),
    id: z.string(),
    title: z.string().optional(),
    altText: z.string().optional(),
    type: z.string().optional(),
    orientation: z.string().optional(),
    flags: z.array(GameCardFlagSchema).optional(),
});
const SimpleGameCardGridBladeTypeValues = ["simpleGameCardGrid"];
export const SimpleGameCardGridBladeTypesSchema = z.enum(SimpleGameCardGridBladeTypeValues);
export const SimpleGameCardGridBladeTypes = SimpleGameCardGridBladeTypesSchema.enum;
export const GameCardListBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema.optional(),
    header: BladeHeaderSchema.optional(),
    items: z.array(GameCardItemSchema).optional(),
    async: AsyncConfigSchema.optional(),
});
export const GameCardListBladesContractSchema = GameCardListBladeSchema.extend({
    type: SimpleGameCardGridBladeTypesSchema,
});
export const SimpleGameCardGridContractSchema = GameCardListBladesContractSchema.extend({
    type: z.literal(SimpleGameCardGridBladeTypes.simpleGameCardGrid),
});
//# sourceMappingURL=index.js.map